<template>
    <div
        ref="name"
        :class="{ 'staff-list-cell': true, 'staff-list-cell-overflow-end': overflowEnd }"
    >
        <span
            v-for="(item, index) in orgNameList"
            v-show="index < showOrgCount"
            :key="item + index"
            class="staff-list-cell__name"
        >
            <span class="staff-list-cell__name-content">{{ item }}</span><span
                v-if="index < showOrgCount - 1"
                class="staff-list-cell__name-comma"
            >,</span>
        </span>
        <span
            v-for="(item, index) in nameList"
            v-show="index < showCount"
            :key="item + index"
            class="staff-list-cell__name"
        >
            <span class="staff-list-cell__name-content">{{ item }}</span><span
                v-if="index < showCount - 1"
                class="staff-list-cell__name-comma"
            >,</span>
        </span>
        <more-items-tip
            v-if="isOverflow"
            :list="nameList"
            :org-list="orgNameList"
            :max-num="55"
            clazz="staff-list-cell__overflow"
            unit="人"
        />
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import moreItemsTip from '../more-items-tip';
/* eslint-disable */

const req = require.context('@/assets/icons', false, /[^\.]+\.svg$/);
Icon.addSprites(req);

export default {
    name: 'StaffListCell',
    components: {
        moreItemsTip
    },
    props: {
        staffList: {
            type: Object,
            default: []
        }
    },
    data() {
        const nameList = [];
        const orgNameList = [];
        if(this.staffList.staffList) {
                this.staffList.staffList.forEach(item => {
                nameList.push(item.name);
            });
        }
        if(this.staffList.orgList) {
            this.staffList.orgList.forEach(item=>{
                orgNameList.push(item.FName);
            });
        }
        return {
            nameList,
            orgNameList,
            showCount: nameList.length,
            showOrgCount: orgNameList.length,
            isOverflow: false,
            overflowEnd: false
        };
    },
    computed: {},
    watch: {
        staffList(newValue) {

            const nameList = [];
            const orgNameList = [];
            newValue && newValue.staffList.forEach(item => {
                nameList.push(item.name);
            });
            newValue && newValue.orgList.forEach(item => {
                orgNameList.push(item.FName);
            });
            this.nameList = nameList;
            this.showCount = nameList.length;
            this.orgNameList = orgNameList;
            this.showOrgCount = orgNameList.length
            this.isOverflow = false;
            this.overflowEnd = false;
            this.$nextTick(function() {
                this.reduceName();
            });
        }
    },
    mounted() {
        this.reduceName();
        console.log(this.nameList,this.orgNameList);
    },
    methods: {
        getNameComma(index) {
            return index < this.showCount - 1 ? ',' : '' &&  index < this.showOrgCount - 1 ? ',' : '';
        },
        reduceName() {
            if (this.$refs.name.scrollHeight > this.$refs.name.offsetHeight) {
                if (!this.isOverflow) this.isOverflow = true;
                this.showCount = 1;
                this.showOrgCount = 1;
                this.$nextTick(this.increaseName);
            } else {
                this.overflowEnd = true;
            }
        },
        increaseName() {
            if (this.$refs.name.scrollHeight == this.$refs.name.offsetHeight) {
                this.showCount++;
                this.showOrgCount++;
                this.$nextTick(this.increaseName);
            } else {
                this.showCount--;
                this.showOrgCount--;
                this.overflowEnd = true; // overflowEnd表示在终止迭代后，强制设置css为overflow: hidden
            }
        }
    }
};
</script>

<style lang="less">
@import '~@/common/common';

.staff-list-cell {
    max-height: 65px;
    overflow: auto;

    &__name,
    &__overflow {
        float: left;
        line-height: 20px;
    }

    &__name {
        margin-right: 5px;
        &-content,
        &-comma {
            vertical-align: middle;
            display: inline-block;
        }
        &-content {
            max-width: 100px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
}
.staff-list-cell-overflow-end {
    overflow: hidden;
}
</style>
